import React from "react";
import { Chip } from "@mui/material";

const StatusChip = ({ status, size = "small", ...props }) => {
  const getColor = (status) => {
    switch ((status || "").toLowerCase()) {
      case "active":
        return { color: "#fff", backgroundColor: "#4caf50" }; // green
      case "incoming":
        return { color: "#fff", backgroundColor: "#2196f3" }; // blue
      case "expired":
        return { color: "#fff", backgroundColor: "#f44336" }; // red
      default:
        return { color: "#fff", backgroundColor: "#9e9e9e" }; // grey
    }
  };

  return (
    <Chip
      label={status || "unknown"}
      size={size}
      sx={{ mt: 1, ...getColor(status) }}
      {...props}
    />
  );
};

export default StatusChip;
